import { StyleFactory } from '@/components/base/style';

const style = StyleFactory.createStyle({
  backgroundColor: 'red'
});

const ProgressBarStyle = `
  <style>
    :host {
        width: 100%;
        max-width: 740px;
    }
    .progress-bar-container {
        width: 100%;
        display: flex;
        flex-direction: column;
        gap: 4px;
    }
    .text-container {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
    }
    .progress-container {
        width: 100%;
        height: 8px;
        border-radius: 99px;
        border: 1px solid #8AE5D3;
        background-color: #FFF;
    }
    .progress-move {
        width: 1%;
        height: 100%;
        border-radius: 99px;
        background-color: #8AE5D3;
    }
  </style>
`;

export default ProgressBarStyle;
